var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fields mb-4"},[_c('h4',[_vm._v(_vm._s(_vm.$t('Events')))]),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
        id: 'events_game.pause',
        label: 'Game pause',
        disabled: false,
        description: 'Show a pop-up when the game are on pause or unpause',
        values: _vm.fieldValues('on_off'),
        target: 'game'
      },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
        id: 'events_game.fine',
        label: 'Road fine',
        disabled: false,
        description: 'Show a pop-up when you get a road fine',
        values: _vm.fieldValues('on_off'),
        target: 'game'
      },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
        id: 'events_game.tollgate',
        label: 'Toll gate',
        disabled: false,
        description: 'Show a pop-up when you pass through a toll gate',
        values: _vm.fieldValues('on_off'),
        target: 'game'
      },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
        id: 'events_game.ferry',
        label: 'Ferry travel',
        disabled: false,
        description: 'Show a pop-up when you use a ferry',
        values: _vm.fieldValues('on_off'),
        target: 'game'
      },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
        id: 'events_game.train',
        label: 'Train travel',
        disabled: false,
        description: 'Show a pop-up when you use a train',
        values: _vm.fieldValues('on_off'),
        target: 'game'
      },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
        id: 'events_game.refuel-payed',
        label: 'Refuel payed',
        disabled: false,
        description:
          'Show a pop-up when you have been refueled your truck tank',
        values: _vm.fieldValues('on_off'),
        target: 'game'
      },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
        id: 'events_job.cancelled',
        label: 'Job canceled',
        disabled: false,
        description: 'Show a pop-up when a job was canceled',
        values: _vm.fieldValues('on_off'),
        target: 'game'
      },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
        id: 'events_job.delivered',
        label: 'Job delivered',
        disabled: false,
        description: 'Show a pop-up when a job was delivered',
        values: _vm.fieldValues('on_off'),
        target: 'game'
      },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
        id: 'events_job.finished',
        label: 'Job finished',
        disabled: false,
        description: 'Show a pop-up when a job was finished',
        values: _vm.fieldValues('on_off'),
        target: 'game'
      },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
        id: 'events_job.started',
        label: 'Job started',
        disabled: false,
        description: 'Show a pop-up when a job was started',
        values: _vm.fieldValues('on_off'),
        target: 'game'
      },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
        id: 'events_navigation.speed-limit',
        label: 'Speed limit',
        disabled: false,
        description: 'Show a pop-up when the speed limit change',
        values: _vm.fieldValues('on_off'),
        target: 'game'
      },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
        id: 'events_trailers.coupling',
        label: 'Trailer coupled',
        disabled: false,
        description: 'Show a pop-up when the trailer was coupled to the truck',
        values: _vm.fieldValues('on_off'),
        target: 'game'
      },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
        id: 'events_trailers.damage',
        label: 'Trailer damage',
        disabled: false,
        description: 'Show a pop-up when the damage increase on the trailer',
        values: _vm.fieldValues('on_off'),
        target: 'game'
      },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
        id: 'events_truck.cruise-control',
        label: 'Cruise control enabled',
        disabled: false,
        description: 'Show a pop-up when the cruise control is enabled',
        values: _vm.fieldValues('on_off'),
        target: 'game'
      },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
        id: 'events_truck.cruise-control-increase',
        label: 'Cruise control increase',
        disabled: false,
        description: 'Show a pop-up when the cruise control increase',
        values: _vm.fieldValues('on_off'),
        target: 'game'
      },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
        id: 'events_truck.cruise-control-decrease',
        label: 'Cruise control decrease',
        disabled: false,
        description: 'Show a pop-up when the cruise control decrease',
        values: _vm.fieldValues('on_off'),
        target: 'game'
      },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
        id: 'events_truck.warning message',
        label: 'Truck warning message',
        disabled: false,
        description: 'Show a pop-up for all warning message of truck',
        values: _vm.fieldValues('on_off'),
        target: 'game'
      },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
        id: 'events_truck.emergency message',
        label: 'Truck emergency message',
        disabled: false,
        description: 'Show a pop-up for all emergency message of truck',
        values: _vm.fieldValues('on_off'),
        target: 'game'
      },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
        id: 'events_truck.electric',
        label: 'Truck electric message',
        disabled: false,
        description: 'Show a pop-up when the truck contact was on',
        values: _vm.fieldValues('on_off'),
        target: 'game'
      },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
        id: 'events_truck.engine',
        label: 'Truck engine start',
        disabled: false,
        description: 'Show a pop-up when the truck engine start',
        values: _vm.fieldValues('on_off'),
        target: 'game'
      },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
        id: 'events_truck.park',
        label: 'Truck parking brake',
        disabled: false,
        description: 'Show a pop-up when the truck parking brake are on',
        values: _vm.fieldValues('on_off'),
        target: 'game'
      },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
        id: 'events_truck.damage',
        label: 'Truck damage',
        disabled: false,
        description: 'Show a pop-up when the truck damage increase',
        values: _vm.fieldValues('on_off'),
        target: 'game'
      },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
        id: 'events_truck.refuel',
        label: 'Truck refuel',
        disabled: false,
        description: 'Show a pop-up when the truck refuel tank was full',
        values: _vm.fieldValues('on_off'),
        target: 'game'
      },false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }